import { Col, Row } from "antd"
import ProductNoDesignPreview from "./ProductNoDesignPreview"
import ProductPanel from "./ProductPanel"

const ProductNoDesign = () => {
  return  (
    <Row justify="center" className="page product__no_design">
      <Col className="page__section">
        <Row justify="center" gutter={[15, 15]}>
          <Col xs={24} md={24} lg={15} xl={{ flex: 1 }}>
            <Row>
              <Col span={24}>
                <ProductNoDesignPreview />
              </Col>
            </Row>

          </Col>
          <Col xs={24} md={20} lg={9} xl={{ flex: "45rem" }}>
            <Row>
              <Col span={24}>
                <ProductPanel />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default ProductNoDesign